import MuseumDetails from "./MuseumDetails";

export default MuseumDetails;
